import React, { lazy } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from '../components/ProtectedRoute';
import RouteErrorBoundary from '../components/RouteErrorBoundary';
import { protectedAreaProps } from './requireAuth';
const AdminLayout = lazy(() => import('../components/admin/AdminLayout').then((module) => ({ default: module.AdminLayout })));
const PlatformOverview = lazy(() => import('../pages/patform-overview'));
const UserManagement = lazy(() => import('../pages/admin/UserManagement'));
const BannerManagement = lazy(() => import('../pages/admin/BannerManagement'));
const AdminCoupons = lazy(() => import('../pages/admin/AdminCoupons'));
const AdminAnalyticsDashboardPage = lazy(() => import('../pages/admin/AdminAnalyticsDashboard'));
const VideoAssets = lazy(() => import('../pages/admin/VideoAssets'));
const AdminColleges = lazy(() => import('../pages/admin/Colleges'));
const AllCourses = lazy(() => import('../pages/course-analytics/AllCourses'));
const SessionsPage = lazy(() => import('../pages/SessionsPage'));
const AdminDashboardPage = lazy(() => import('../components/admin').then((module) => ({ default: module.AdminDashboardPage })));
const AdminCourseAnalyticsPage = lazy(() => import('../components/admin').then((module) => ({ default: module.AdminCourseAnalyticsPage })));
const InviteTeacherPage = lazy(() => import('../pages/admin/InviteTeacherPage'));
const UserDetailPage = lazy(() => import('../pages/admin/UserDetailPage'));
const BlogsPage = lazy(() => import('../pages/admin/cms/BlogsPage'));
const TestimonialsPage = lazy(() => import('../pages/admin/cms/TestimonialsPage'));
const VideosPage = lazy(() => import('../pages/admin/cms/VideosPage'));
const PrivacyPolicyPage = lazy(() => import('../pages/admin/cms/PrivacyPolicyPage'));
const AuditOrders = lazy(() => import('../pages/admin/audit/AuditOrders'));
const AuditEnrollments = lazy(() => import('../pages/admin/audit/AuditEnrollments'));
const AuditTransactions = lazy(() => import('../pages/admin/audit/AuditTransactions'));
const AuditLogs = lazy(() => import('../pages/admin/audit/AuditLogs'));
const BroadcastPage = lazy(() => import('../pages/admin/BroadcastPage'));
const FeatureUnavailable = lazy(() => import('../pages/admin/FeatureUnavailable'));
const NotFound = lazy(() => import('../pages/NotFound'));

const adminShell = (
  <ProtectedRoute>
    <AdminLayout />
  </ProtectedRoute>
);

export const adminRoutes = (
  <>
  <Route path="/admin" element={adminShell} {...protectedAreaProps}>
    <Route errorElement={<RouteErrorBoundary />}>
      <Route index element={<PlatformOverview />} />
      <Route path="platform-overview" element={<PlatformOverview />} />
      <Route path="dashboard" element={<AdminAnalyticsDashboardPage />} />
      <Route path="legacy-dashboard" element={<AdminDashboardPage />} />
      <Route path="video-assets" element={<VideoAssets />} />
      <Route path="user-management" element={<UserManagement />} />
      <Route path="users/:id" element={<UserDetailPage />} />
      <Route path="course-analytics" element={<AdminCourseAnalyticsPage />} />
      <Route path="colleges" element={<AdminColleges />} />
      <Route path="all-courses" element={<AllCourses />} />
      <Route path="coupons" element={<AdminCoupons />} />
      <Route path="banners" element={<BannerManagement />} />
      <Route path="sessions" element={<SessionsPage />} />
      <Route path="teacher-invitations" element={<InviteTeacherPage />} />
      <Route path="teacher-invitations/new" element={<InviteTeacherPage />} />
      <Route path="cms/blogs" element={<BlogsPage />} />
      <Route path="cms/testimonials" element={<TestimonialsPage />} />
      <Route path="cms/videos" element={<VideosPage />} />
      <Route path="cms/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="audit" element={<AuditOrders />} />
      <Route path="audit/orders" element={<AuditOrders />} />
      <Route path="audit/enrollments" element={<AuditEnrollments />} />
      <Route path="audit/transactions" element={<AuditTransactions />} />
      <Route path="audit/logs" element={<AuditLogs />} />
      <Route path="broadcasts" element={<BroadcastPage />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Route>
  {/* Student analytics has no backend support yet */}
  <Route path="/student-analytics" element={adminShell} {...protectedAreaProps}>
    <Route errorElement={<RouteErrorBoundary />}>
      <Route path="progress" element={<FeatureUnavailable feature="Progress Tracking" icon="TrendingUp" />} />
      <Route path="patterns" element={<FeatureUnavailable feature="Engagement Patterns" icon="BarChart3" />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Route>
  </>
);
